import { useMemo } from 'react';
import { useAppDispatch, useAppSelectorShallow } from 'store/hooks';
import Switch from 'components/ui/Switch';
import COLOR from 'constants/color';
import { ATTRIB } from 'constants/test';
import { Teacup } from 'assets/icons/revamp';
import InfoCircle from 'assets/icons/InfoCircle';
import Card from 'components/ui/Card';
import { t } from 'services/i18n.service';
import { updateMoreOptionMicroBreak } from 'store/reducer/modal/slice';
import {
  moreOptionsApplicationsSelector,
  moreOptionsMicroBreakSelector
} from 'store/reducer/setting/selectors';

const MicroBreaks: React.FC = () => {
  const dispatch = useAppDispatch();
  const { activity } = useAppSelectorShallow(moreOptionsApplicationsSelector);
  const microBreakActivity = useAppSelectorShallow(
    moreOptionsMicroBreakSelector
  );

  const shouldRunMicroBreaksSwitchBeVisible = useMemo(
    () =>
      Boolean(
        activity?.allowed_apps?.length || activity?.allowed_urls?.length
      ),
    [activity?.allowed_apps?.length, activity?.allowed_urls?.length]
  );

  const handleToggleMicrobreaks = (checked: boolean) => {
    dispatch(updateMoreOptionMicroBreak(checked));
  };

  return (
    <Card className='flex items-start justify-between ~gap-4/6'>
      <div className='flex flex-col ~gap-1/2'>
        <div className='flex items-center ~gap-3/6'>
          <h3 className='~text-xs/base font-semibold flex items-center ~gap-1/2'>
            <Teacup styles='~w-4/5 ~h-4/5' fill={COLOR.PRIMARY.LIGHT_900} />
            {t('tabs_revamp.allowed_apps_tab.run_microbreaks')}
          </h3>
          <Switch
            checked={microBreakActivity?.run_micro_breaks ?? false}
            onChange={handleToggleMicrobreaks}
            size='medium'
            variant='default'
            disabled={!shouldRunMicroBreaksSwitchBeVisible}
            data-testid={ATTRIB.DATA_TESTID.MICRO_BREAK_SWITCH}
          />
        </div>
        <p className='~text-xs/sm text-gray-600 dark:text-gray-400 ~ml-0/0'>
          {t('tabs_revamp.allowed_apps_tab.run_microbreaks_description')}
        </p>
        <div className='flex items-center ~gap-1.5/2 ~ml-0/0'>
          <InfoCircle
            styles='~w-3.5/4 ~h-3.5/4'
            fill={COLOR.SEMANTIC.INFO_SOFT}
          />
          <span className='~text-xs/sm text-primary-900 dark:text-blue-400'>
            {t('tabs_revamp.allowed_apps_tab.run_microbreaks_info')}
          </span>
        </div>
      </div>
    </Card>
  );
};

export default MicroBreaks;
